import Vue from 'vue'
import Vuex from 'vuex'
import Meta from 'vue-meta'
import ClientOnly from 'vue-client-only'
import NoSsr from 'vue-no-ssr'
import { createRouter } from './router.js'
import NuxtChild from './components/nuxt-child.js'
import NuxtError from '../layouts/error.vue'
import Nuxt from './components/nuxt.js'
import App from './App.js'
import { setContext, getLocation, getRouteData, normalizeError } from './utils'
import { createStore } from './store.js'

/* Plugins */

import nuxt_plugin_sentryserver_b28c2372 from 'nuxt_plugin_sentryserver_b28c2372' // Source: ./sentry.server.js (mode: 'server')
import nuxt_plugin_sentryclient_41007cbf from 'nuxt_plugin_sentryclient_41007cbf' // Source: ./sentry.client.js (mode: 'client')
import nuxt_plugin_workbox_3d1afc42 from 'nuxt_plugin_workbox_3d1afc42' // Source: ./workbox.js (mode: 'client')
import nuxt_plugin_nuxticons_62a641a5 from 'nuxt_plugin_nuxticons_62a641a5' // Source: ./nuxt-icons.js (mode: 'all')
import nuxt_plugin_adsbygoogle_3434da39 from 'nuxt_plugin_adsbygoogle_3434da39' // Source: ./adsbygoogle.js (mode: 'all')
import nuxt_plugin_googletagmanager_42556e62 from 'nuxt_plugin_googletagmanager_42556e62' // Source: ./google-tag-manager.js (mode: 'client')
import nuxt_plugin_axios_5b346183 from 'nuxt_plugin_axios_5b346183' // Source: ./axios.js (mode: 'all')
import nuxt_plugin_lazyimages_2d6ce48a from 'nuxt_plugin_lazyimages_2d6ce48a' // Source: ../plugins/lazy-images (mode: 'all')
import nuxt_plugin_socialsharing_3c990372 from 'nuxt_plugin_socialsharing_3c990372' // Source: ../plugins/social-sharing (mode: 'all')
import nuxt_plugin_vueawesome_b4833434 from 'nuxt_plugin_vueawesome_b4833434' // Source: ../plugins/vue-awesome (mode: 'client')
import nuxt_plugin_lazyyoutubevideo_3b9880ae from 'nuxt_plugin_lazyyoutubevideo_3b9880ae' // Source: ../plugins/lazy-youtube-video (mode: 'client')
import nuxt_plugin_vuecookielaw_977804c0 from 'nuxt_plugin_vuecookielaw_977804c0' // Source: ../plugins/vue-cookie-law.js (mode: 'client')

// Component: <ClientOnly>
Vue.component(ClientOnly.name, ClientOnly)

// TODO: Remove in Nuxt 3: <NoSsr>
Vue.component(NoSsr.name, {
  ...NoSsr,
  render (h, ctx) {
    if (process.client && !NoSsr._warned) {
      NoSsr._warned = true

      console.warn('<no-ssr> has been deprecated and will be removed in Nuxt 3, please use <client-only> instead')
    }
    return NoSsr.render(h, ctx)
  }
})

// Component: <NuxtChild>
Vue.component(NuxtChild.name, NuxtChild)
Vue.component('NChild', NuxtChild)

// Component NuxtLink is imported in server.js or client.js

// Component: <Nuxt>
Vue.component(Nuxt.name, Nuxt)

Vue.use(Meta, {"keyName":"head","attribute":"data-n-head","ssrAttribute":"data-n-head-ssr","tagIDKeyName":"hid"})

const defaultTransition = {"name":"page","mode":"out-in","appear":false,"appearClass":"appear","appearActiveClass":"appear-active","appearToClass":"appear-to"}

const originalRegisterModule = Vuex.Store.prototype.registerModule
const baseStoreOptions = { preserveState: process.client }

function registerModule (path, rawModule, options = {}) {
  return originalRegisterModule.call(this, path, rawModule, { ...baseStoreOptions, ...options })
}

async function createApp(ssrContext, config = {}) {
  const router = await createRouter(ssrContext)

  const store = createStore(ssrContext)
  // Add this.$router into store actions/mutations
  store.$router = router

  // Fix SSR caveat https://github.com/nuxt/nuxt.js/issues/3757#issuecomment-414689141
  store.registerModule = registerModule

  // Create Root instance

  // here we inject the router and store to all child components,
  // making them available everywhere as `this.$router` and `this.$store`.
  const app = {
    head: {"title":"Bookinsicily - Turismo, enogastronomia e cultura in Sicilia","meta":[{"charset":"utf-8"},{"name":"viewport","content":"width=device-width, initial-scale=1"},{"hid":"description","name":"description","content":"Bookinsicily è un sito che raccoglie tutte le notizie presenti su Internet che riguardano eventi della Sicilia in tempo reale. Tutto in tempo reale e su un solo sito."},{"hid":"keywords","name":"keywords","content":"Comiso, News, Notizie Comiso, Ragusa, Provincia di Ragusa, Aeroporto di Comiso, Politica Comiso, Cronaca Comiso, Cultura Comiso, Sport Comiso, Ultime notizie Comiso, Google News Comiso, YouTube Comiso, Flickr Comiso, Instagram Comiso, Twitter Comiso, Facebook Comiso"},{"name":"msapplication-TileColor","content":"#86CFED"},{"hid":"theme-color","name":"theme-color","content":"#86CFED"},{"hid":"mobile-web-app-capable","name":"mobile-web-app-capable","content":"yes"},{"hid":"application-name","name":"application-name","content":"Bookinsicily - Turismo, enogastronomia e cultura in Sicilia"},{"hid":"apple-mobile-web-app-capable","name":"apple-mobile-web-app-capable","content":"yes"},{"hid":"apple-mobile-web-app-status-bar-style","name":"apple-mobile-web-app-status-bar-style","content":"#86CFED"},{"hid":"apple-mobile-web-app-title","name":"apple-mobile-web-app-title","content":"Bookinsicily - Turismo, enogastronomia e cultura in Sicilia"},{"hid":"twitter:card","name":"twitter:card","content":"summary"},{"hid":"twitter:site","name":"twitter:site","content":"@bookinsicily"},{"hid":"og:type","property":"og:type","content":"website"},{"hid":"og:site_name","property":"og:site_name","content":"Bookinsicily - Turismo, enogastronomia e cultura in Sicilia"},{"hid":"og:image","property":"og:image","content":"undefined\u002Fsharer-image.png"},{"hid":"og:title","name":"og:title","property":"og:title","content":"Bookinsicily - Turismo, enogastronomia e cultura in Sicilia"}],"link":[{"rel":"icon","type":"image\u002Fpng","size":"32x32","href":"\u002Ffavicon-32x32.png"},{"rel":"icon","type":"image\u002Fpng","size":"16x16","href":"\u002Ffavicon-16x16.png"},{"rel":"mask-icon","href":"\u002Fsafari-pinned-tab.svg","color":"#86CFED"},{"rel":"preconnect","href":"https:\u002F\u002Ffonts.gstatic.com\u002F","crossorigin":true},{"rel":"preconnect","href":"https:\u002F\u002Fi.ytimg.com","crossorigin":true},{"rel":"preconnect","href":"https:\u002F\u002Ffonts.googleapis.com","crossorigin":true},{"rel":"preconnect","href":"https:\u002F\u002Fwww.google-analytics.com","crossorigin":true},{"rel":"preconnect","href":"https:\u002F\u002Fwww.googletagmanager.com","crossorigin":true},{"rel":"stylesheet","href":"\u002Fmain.css"},{"rel":"apple-touch-icon","href":"\u002Fapple-touch-icon.png","sizes":"180x180"},{"rel":"manifest","href":"\u002F_nuxt\u002Fmanifest.1a741611.json"},{"rel":"shortcut icon","href":"\u002F_nuxt\u002Ficons\u002Ficon_64x64.8d0e87.png"}],"style":[],"script":[{"src":"\u002F\u002Fwww.googletagmanager.com\u002Fgtm.js?id=GTM-N5K4WQG&l=dataLayer","async":true},{"async":true,"src":"\u002F\u002Fpagead2.googlesyndication.com\u002Fpagead\u002Fjs\u002Fadsbygoogle.js"},{"innerHTML":"\n      (adsbygoogle = window.adsbygoogle || []).push({\n        google_ad_client: \"ca-pub-5478103525404907\",\n        enable_page_level_ads: false\n      });\n  "}],"noscript":[{"hid":"gtm-noscript","innerHTML":"\u003Ciframe src=\"\u002F\u002Fwww.googletagmanager.com\u002Fns.html?id=GTM-N5K4WQG&l=dataLayer\" height=\"0\" width=\"0\" style=\"display:none;visibility:hidden\"\u003E\u003C\u002Fiframe\u003E","pbody":true}],"__dangerouslyDisableSanitizersByTagID":{"gtm-noscript":["innerHTML"]},"__dangerouslyDisableSanitizers":["script"],"htmlAttrs":{"lang":"it"}},

    store,
    router,
    nuxt: {
      defaultTransition,
      transitions: [defaultTransition],
      setTransitions (transitions) {
        if (!Array.isArray(transitions)) {
          transitions = [transitions]
        }
        transitions = transitions.map((transition) => {
          if (!transition) {
            transition = defaultTransition
          } else if (typeof transition === 'string') {
            transition = Object.assign({}, defaultTransition, { name: transition })
          } else {
            transition = Object.assign({}, defaultTransition, transition)
          }
          return transition
        })
        this.$options.nuxt.transitions = transitions
        return transitions
      },

      err: null,
      dateErr: null,
      error (err) {
        err = err || null
        app.context._errored = Boolean(err)
        err = err ? normalizeError(err) : null
        let nuxt = app.nuxt // to work with @vue/composition-api, see https://github.com/nuxt/nuxt.js/issues/6517#issuecomment-573280207
        if (this) {
          nuxt = this.nuxt || this.$options.nuxt
        }
        nuxt.dateErr = Date.now()
        nuxt.err = err
        // Used in src/server.js
        if (ssrContext) {
          ssrContext.nuxt.error = err
        }
        return err
      }
    },
    ...App
  }

  // Make app available into store via this.app
  store.app = app

  const next = ssrContext ? ssrContext.next : location => app.router.push(location)
  // Resolve route
  let route
  if (ssrContext) {
    route = router.resolve(ssrContext.url).route
  } else {
    const path = getLocation(router.options.base, router.options.mode)
    route = router.resolve(path).route
  }

  // Set context to app.context
  await setContext(app, {
    store,
    route,
    next,
    error: app.nuxt.error.bind(app),
    payload: ssrContext ? ssrContext.payload : undefined,
    req: ssrContext ? ssrContext.req : undefined,
    res: ssrContext ? ssrContext.res : undefined,
    beforeRenderFns: ssrContext ? ssrContext.beforeRenderFns : undefined,
    ssrContext
  })

  function inject(key, value) {
    if (!key) {
      throw new Error('inject(key, value) has no key provided')
    }
    if (value === undefined) {
      throw new Error(`inject('${key}', value) has no value provided`)
    }

    key = '$' + key
    // Add into app
    app[key] = value
    // Add into context
    if (!app.context[key]) {
      app.context[key] = value
    }

    // Add into store
    store[key] = app[key]

    // Check if plugin not already installed
    const installKey = '__nuxt_' + key + '_installed__'
    if (Vue[installKey]) {
      return
    }
    Vue[installKey] = true
    // Call Vue.use() to install the plugin into vm
    Vue.use(() => {
      if (!Object.prototype.hasOwnProperty.call(Vue.prototype, key)) {
        Object.defineProperty(Vue.prototype, key, {
          get () {
            return this.$root.$options[key]
          }
        })
      }
    })
  }

  // Inject runtime config as $config
  inject('config', config)

  if (process.client) {
    // Replace store state before plugins execution
    if (window.__NUXT__ && window.__NUXT__.state) {
      store.replaceState(window.__NUXT__.state)
    }
  }

  // Add enablePreview(previewData = {}) in context for plugins
  if (process.static && process.client) {
    app.context.enablePreview = function (previewData = {}) {
      app.previewData = Object.assign({}, previewData)
      inject('preview', previewData)
    }
  }
  // Plugin execution

  if (process.server && typeof nuxt_plugin_sentryserver_b28c2372 === 'function') {
    await nuxt_plugin_sentryserver_b28c2372(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_sentryclient_41007cbf === 'function') {
    await nuxt_plugin_sentryclient_41007cbf(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_workbox_3d1afc42 === 'function') {
    await nuxt_plugin_workbox_3d1afc42(app.context, inject)
  }

  if (typeof nuxt_plugin_nuxticons_62a641a5 === 'function') {
    await nuxt_plugin_nuxticons_62a641a5(app.context, inject)
  }

  if (typeof nuxt_plugin_adsbygoogle_3434da39 === 'function') {
    await nuxt_plugin_adsbygoogle_3434da39(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_googletagmanager_42556e62 === 'function') {
    await nuxt_plugin_googletagmanager_42556e62(app.context, inject)
  }

  if (typeof nuxt_plugin_axios_5b346183 === 'function') {
    await nuxt_plugin_axios_5b346183(app.context, inject)
  }

  if (typeof nuxt_plugin_lazyimages_2d6ce48a === 'function') {
    await nuxt_plugin_lazyimages_2d6ce48a(app.context, inject)
  }

  if (typeof nuxt_plugin_socialsharing_3c990372 === 'function') {
    await nuxt_plugin_socialsharing_3c990372(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_vueawesome_b4833434 === 'function') {
    await nuxt_plugin_vueawesome_b4833434(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_lazyyoutubevideo_3b9880ae === 'function') {
    await nuxt_plugin_lazyyoutubevideo_3b9880ae(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_vuecookielaw_977804c0 === 'function') {
    await nuxt_plugin_vuecookielaw_977804c0(app.context, inject)
  }

  // Lock enablePreview in context
  if (process.static && process.client) {
    app.context.enablePreview = function () {
      console.warn('You cannot call enablePreview() outside a plugin.')
    }
  }

  // If server-side, wait for async component to be resolved first
  if (process.server && ssrContext && ssrContext.url) {
    await new Promise((resolve, reject) => {
      router.push(ssrContext.url, resolve, (err) => {
        // https://github.com/vuejs/vue-router/blob/v3.4.3/src/util/errors.js
        if (!err._isRouter) return reject(err)
        if (err.type !== 2 /* NavigationFailureType.redirected */) return resolve()

        // navigated to a different route in router guard
        const unregister = router.afterEach(async (to, from) => {
          ssrContext.url = to.fullPath
          app.context.route = await getRouteData(to)
          app.context.params = to.params || {}
          app.context.query = to.query || {}
          unregister()
          resolve()
        })
      })
    })
  }

  return {
    store,
    app,
    router
  }
}

export { createApp, NuxtError }
